import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import ButtonAtom from '../../../@atoms/to_forms/button/button.atom'
import BoxAtom from '../../../@atoms/to_layout/box/box.atom'
import {
  DateScreenModalPayload,
  showBestDateModal,
  showSpecialInstructionModal,
  showStandardDateChoiceModal,
} from '../../../store_redux/reducer/modal.reducer'
import {RootState} from '../../../store_redux'
import {Visit} from '../../../props_reusable/visit'
import Utils from '../../../utils'

const CardVisitActionsComponent: React.FC<
  Pick<
    Visit,
    | 'specialInstructions'
    | 'bookedSlotDetail'
    | 'visitNumber'
    | 'isBookingAllowed'
    | 'isVisitInstructionAllowed'
    | 'visitType'
    | 'isShipmentFailed'
  >
> = function ({
  specialInstructions,
  visitNumber,
  bookedSlotDetail,
  isBookingAllowed,
  isVisitInstructionAllowed,
  visitType,
  isShipmentFailed,
}) {
  const rootState = useSelector((state: RootState) => state)
  const {settings, labels} = rootState
  const dispatch = useDispatch()
  const {isInstructionAllowed, isBestDateVisible} = settings
  const {visitCardHeader} = labels.myOrders
  const isUndatedOrder = Utils.isVisitUndated(bookedSlotDetail?.visitDate)
  const actionsFlag = {
    bookDate: isUndatedOrder && isBookingAllowed,
    changeDate: !!bookedSlotDetail && isBookingAllowed && !isUndatedOrder,
    addInstruction:
      isInstructionAllowed &&
      isVisitInstructionAllowed &&
      !specialInstructions &&
      !!bookedSlotDetail,
    editInstruction:
      isInstructionAllowed &&
      isVisitInstructionAllowed &&
      !!specialInstructions &&
      !!bookedSlotDetail,
  }

  const handleSpecialInstruction = () => {
    const type = actionsFlag.addInstruction ? 'ADD' : 'EDIT'
    dispatch(
      showSpecialInstructionModal({
        type,
        content: specialInstructions || '',
        redirectedFrom: null,
        visitId: visitNumber,
      }),
    )
  }

  const handleBestDate = () => {
    const type = bookedSlotDetail && !isUndatedOrder ? 'CHANGE' : 'BOOK'
    const payload: DateScreenModalPayload = {
      type,
      visitId: visitNumber,
      visitType,
      bookedSlotDetail,
      isShipmentFailed,
    }
    if (isBestDateVisible) dispatch(showBestDateModal(payload))
    else dispatch(showStandardDateChoiceModal(payload))
  }

  const getBookDateBtnText = () => {
    switch (visitType) {
      case 'Delivery':
        return visitCardHeader.buttonBookDeliveryDate
      case 'Collection':
        return visitCardHeader.buttonBookCollectionDate
      default:
        return visitCardHeader.buttonBookExchangeDate
    }
  }

  return (
    <BoxAtom className="btn-wrapper">
      {actionsFlag.bookDate && (
        <ButtonAtom ap_type="primary" fullWidth onClick={handleBestDate}>
          {getBookDateBtnText()}
        </ButtonAtom>
      )}
      {actionsFlag.addInstruction && (
        <ButtonAtom
          ap_type="secondary"
          fullWidth
          onClick={handleSpecialInstruction}
        >
          {visitCardHeader.buttonAddInstruction}
        </ButtonAtom>
      )}
      {actionsFlag.editInstruction && (
        <ButtonAtom
          ap_type="secondary"
          fullWidth
          onClick={handleSpecialInstruction}
        >
          {visitCardHeader.buttonEditInstruction}
        </ButtonAtom>
      )}
      {actionsFlag.changeDate && (
        <ButtonAtom ap_type="secondary" fullWidth onClick={handleBestDate}>
          {isShipmentFailed
            ? visitCardHeader.buttonReschedule
            : visitCardHeader.buttonChangeDate}
        </ButtonAtom>
      )}
    </BoxAtom>
  )
}

export default CardVisitActionsComponent
